import React from 'react';

// Assets
import imgCaltech from '../../assets/img/portfolio/caltech.jpg';
import imgDenarius from '../../assets/img/portfolio/denarius.jpg';
import imgLuisCardoso from '../../assets/img/portfolio/luis_cardoso.jpg';
import imgMapeandoAra from '../../assets/img/portfolio/mapeandoara.jpg';
import imgTranca from '../../assets/img/portfolio/tranca.jpg';
import imgUfizzi from '../../assets/img/portfolio/ufizzi.jpg';

// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

// Carousel
import Carousel from 'react-multi-carousel';

// Custom Components
import ProjectItem from '../ProjectItem';
import SectionTitle from '../SectionTitle';

// React Scroll
import { Element } from 'react-scroll';

import 'react-multi-carousel/lib/styles.css';
import './styles.css';

const Services = () => {
    // Controls the amout of items
    const responsive = {
        standard: {
            breakpoint: { max: 4000, min: 991 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 991, min: 767 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 767, min: 0 },
            items: 1,
        },
    };

    const projectList = [
        {
            key: 1,
            image: imgCaltech,
            title: 'Caltech',
            content:
                'Site e Blog da Caltech, Empresa Júnior de Consultoria em Alimentos.',
            link: 'https://www.caltechconsultoria.com/',
        },
        {
            key: 2,
            image: imgDenarius,
            title: 'Denarius',
            content: 'Página da Denárius Assessoria Contábil.',
            link: 'http://www.denariuscontabil.com.br/',
        },
        {
            key: 3,
            image: imgLuisCardoso,
            title: 'Luis Cardoso',
            content: 'Desenvolvimento do site do Luis Cardoso.',
        },
        {
            key: 4,
            image: imgMapeandoAra,
            title: 'Mapeando Araranguá',
            content:
                'Plataforma do projeto de extensão Mapeando Araranguá, da UFSC.',
            link: 'http://mapeandoara.sites.ufsc.br/',
        },
        {
            key: 5,
            image: imgTranca,
            title: 'Tranca Eletrônica',
            content: 'Controle de acesso RFID de um prédio.',
        },
        {
            key: 6,
            image: imgUfizzi,
            title: 'Ufizzi',
            content: 'Site da Ufizzi, loja de móveis para escritório.',
            link: 'http://www.bemnaturalmoveis.com.br/',
        },
    ];

    return (
        <Element name="projects" className="projects-section">
            <Container as="section" className="text-center">
                <Row className="mb-4">
                    <SectionTitle>Nossos Projetos</SectionTitle>
                    <p className="subtitle w-100">
                        Projetos que foram desenvolvidos por nossa empresa.
                    </p>
                </Row>
                <Carousel
                    responsive={responsive}
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={10000}
                    customTransition="all 1s"
                    arrows={false}
                >
                    {projectList.map(project => {
                        if (project.link)
                            return (
                                <a
                                    key={`project-${project.key}`}
                                    href={project.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <ProjectItem {...project} />
                                </a>
                            );
                        else return <ProjectItem {...project} />;
                    })}
                </Carousel>
            </Container>
        </Element>
    );
};

export default Services;
